/**
 * Generates a unique ID
 * @returns {string} Unique ID
 */
export function generateId() {
  return Math.random().toString(36).slice(2) + Date.now().toString(36);
}

/**
 * Gets initial letter(s) from name
 * @param {string} name - Name to get initial from
 * @returns {string} Initial letter
 */
export function initialLetter(name) {
  if (!name) return "?";
  return name.charAt(0).toUpperCase();
}
